<p
  class="text-xl md:text-3xl font-semibold my-2"
  [ngStyle]="{ color: theme() && theme()[0] && theme()[0].title }">
  <ng-content></ng-content>
</p>
